import styled from 'styled-components';

export const TableHeader = styled.th<{
  width?: number;
}>`
  position: relative;
  width: ${({ width }) => `${width}%`};
`;
